/**
 * Lazy entry-points for the transport cartography components.
 *
 * Leaflet + react-leaflet weigh ~170 KB gzipped. Loading them only when the
 * user actually opens a map keeps the initial bundle fast for everyone.
 *
 * Usage:
 *
 *   const TransportLegMap = lazy(() => import("src/components/Transport/Map").then(m => ({ default: m.TransportLegMap })));
 *
 * Or directly with the helpers below:
 *
 *   const LazyLegMap = LazyTransportLegMap;
 */
import { lazy } from "react";

export const LazyTransportLegMap = lazy(() => import("./TransportLegMap"));
export const LazyTransportCircuitMap = lazy(() => import("./TransportCircuitMap"));
export const LazyTransportSelectionMap = lazy(() => import("./TransportSelectionMap"));
export const LazyProductTransportDashboard = lazy(() => import("./ProductTransportDashboard"));
export const LazyTransportEmptyMapPreview = lazy(() => import("./TransportEmptyMapPreview"));
